module.exports = __webpack_public_path__ + "img/u1208.e6363bdc.png";